import { Monitor, Moon, Sun } from 'lucide-react'
import { Dropdown, IconButton } from '@/components/ui'
import { applyTheme, useUiStore, type Theme } from '@/stores'
import { useT } from '@/internationalization/i18n'

/**
 * Three states, not two: light, dark, and follow the OS.
 *
 * 'system' is the default and has to stay reachable — a two-way toggle traps
 * anyone whose OS switches at sunset into whichever value they last picked.
 */
export function ThemeToggle() {
  const t = useT()
  const theme = useUiStore((s) => s.theme)
  const setTheme = useUiStore((s) => s.setTheme)

  const select = (next: Theme) => {
    setTheme(next)
    applyTheme(next)
  }

  const icon = theme === 'dark' ? <Moon /> : theme === 'light' ? <Sun /> : <Monitor />

  return (
    <Dropdown
      heading={t('theme.heading')}
      trigger={({ toggle }) => <IconButton label={t('theme.change')} icon={icon} onClick={toggle} />}
      items={[
        { id: 'light', label: t('theme.light'), icon: <Sun />, selected: theme === 'light', onSelect: () => select('light') },
        { id: 'dark', label: t('theme.dark'), icon: <Moon />, selected: theme === 'dark', onSelect: () => select('dark') },
        { id: 'system', label: t('theme.system'), icon: <Monitor />, selected: theme === 'system', onSelect: () => select('system') },
      ]}
    />
  )
}
